import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
//import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  constructor(public service: UserService,
    //private toastr:ToastrService
    private gnotify : GlobalNotification
    ) { }

  ngOnInit() {
    this.service.formPasswordModel.reset();
  }
  onSubmit() {
    console.log("onSubmit");
    this.service.changePassword().subscribe(
      (res : any) => {
        if (res.succeeded) {
          this.service.formPasswordModel.reset();
          ////this.toastr.success("The password changed!", "Change password successful");
          this.gnotify.showSnackBar('Change password', 'The password changed!', "success");
        }
        else {
          this.service.formPasswordModel.reset();
          res.errors.forEach(element => {
            ////this.toastr.error(element.description, "Change password failed");
            this.gnotify.showSnackBar('Change password', element.description, "error");
          });
        }
      },
        err => {
          this.service.formPasswordModel.reset();
          if(err.status == 400)
          {
            ////this.toastr.error(err.error.message, "Error");
            this.gnotify.showSnackBar('Change password', err.error.message, "error");
          }
          else{
            ////this.toastr.error(err.desription, "Error");
            this.gnotify.showSnackBar('Change password', err.desription, "error");
          }

        }
    );

  }

}
